export const brigadeMapTasksListUtils = {
  methods: {
    prepareRequestsListConfig: function (configKey, requests) {
      if (!this[configKey] || !this[configKey].pageLoading) {
        this[configKey] = this.getRequestsListConfig(requests)
      }
    },
    getRequestsListConfig: function (itemsSrc) {
      return {
        isEmpty: !itemsSrc.length,
        itemsSrc: itemsSrc,
        itemsToShow: [],
        itemsLeft: 0,
        nextPageSize: 0,
        pageSize: 10,
        pageLoading: false
      }
    }
  }
}
